import "./WhyUs.css";
function WhyUs(): JSX.Element {
    return (
        <div className="WhyUs">
            <div className="WhyUsContent">
                <img src={require('../../../../../Assets/Images/HomePage/2.png')} alt="" />
                <img src={require('../../../../../Assets/Images/HomePage/3.png')} alt="" />
            </div>
        </div>
    );
}

export default WhyUs;
